import React, { Component } from "react";
// import Image from "react-bootstrap/Image";
import { SuperAdminTopSearchIcon } from "../../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";

import { ReferralTableUserHeader } from "../ReferralTable/ReferralTableUserHeader";
// import Fillter from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter"; 
import { ReferralTableUserBody } from "../ReferralTable/ReferralTableUserBody";
// import SuperAdminProfilePopup from "../../../superAdminReusable/reusablePopupSuperAdmin/superadminprofilepopup/SuperAdminProfilePopup";
// import DeletePopup from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_refrrals_get } from "../../../../../store/actions/SuperAdminActions/superadminreferralsaction";
import { TopNavigationReferralTab } from "../SuperAdminReferralsCode";
import BasicPagination from "../../../../Pagination/Pagination";
import {
  FilterMain,
  SearchWithIconInput,
  SortTopRight,
} from "./ReferralUserComponent";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import { Table, Form, Col, Row,Image } from "react-bootstrap";
import { MenuItem } from "@material-ui/core";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
export class ReferralAffiliatesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      dateQuery: {},
      sort: 1,
      filterValue: "",
      filterValueChecked: "",
      search: "",
      page: 1,
      start :0,
      end : 10,
      wholeData:[],
    };
  }

  componentDidMount() {
    this.getData(this.dateQuery);
    // this.props.superadmin_refrrals_get(token, "Affiliates");
  }

  getData = (date) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refrrals_get(
      token,
      "Affiliates",
      date?.startDate,
      date?.endDate
    );
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state?.referrals &&
      this.state?.referrals?.length !== nextProps.referrals &&
      nextProps.referrals?.length
    ) {
      this.setState({ referrals: nextProps.referrals });
    }
  }
  handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    this.setState({ start: calcStart });
    this.setState({ end: pageNo * 10 });
    this.setState({ page: pageNo });
    //page = pageNo;
  };
  renderTableDataBody = () => {
    let referralsData = this.state?.referrals;
    const { sort, filterValueChecked, search } = this.state;
    if (search) {
      let searchData = new RegExp(search, "i");
      referralsData = referralsData.filter((getall) => {
        if (
          searchData.test(
            getall?.referee_id?.name
          )
        ) {
          return getall;
        }
          else if (
            searchData.test(
              getall?.referred_id?.first_name +
              " " +
              getall?.referred_id?.last_name
            )
          ) {
            return getall;
        } else if (searchData.test(getall?.referee_id?.referral_code)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    return (
      <React.Fragment>
        {referralsData
         .sort((a, b) => {
          if (sort === 1) {
            if (new Date(a.createdAt) < new Date(b.createdAt)) return 1;
            if (new Date(a.createdAt) > new Date(b.createdAt)) return -1;
            return 0;
          } else if (sort === 2) {
            if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
            if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
            return 0;
          }
        })
        .filter((e) => {
          if(filterValueChecked){
          if (filterValueChecked === "No") {
            return !e?.referral_qualified;
          } else if(filterValueChecked === "Yes") {
            return  e?.referral_qualified;
          } else
          return true
        }
        return true
        })
        // .filter((e) => {
        //   if (search?.toString()?.toLowerCase()) {
        //     return (
        //       e?.referee_id?.referral_code?.toString()?.toLowerCase()?.includes(search) ||
        //       e?.referee_id?.first_name?.toString()?.toLowerCase()?.includes(search) ||
        //       e?.referee_id?.last_name?.toString()?.toLowerCase()?.includes(search)
        //     );
        //   }
        //   return true;
        // })
        .slice(this.state.start, this.state.end)
          .map((data, index) => {
            return (
              <ReferralTableUserBody
                key={index}
                id={data._id}
                data={data}
                sendData={referralsData}
                setDataWhole={(e) => this.setState({ wholeData: e })}
                src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                userName="Kelly McDonald"
                number="+91 8412854369"
                referralCode={data.referee_id && data.referee_id.referral_code}
                used="200"
                refuserId={data.referred_id && data.referred_id._id}
                refree={{
                  src: data.referee_id && data.referee_id.profile_photo[0],
                  name:
                  `${data?.referee_id?.name || "Name not Given"}`,
                }}
                referred={{
                  src: data.referee_id && data.referee_id.profile_photo[0],
                  name:
                  `${data?.referred_id?.first_name || "Name not"} ${
                    data?.referred_id?.last_name || "Given"
                  }`,
                }}
                referralQualified={data?.referral_qualified ? "Yes" : "No"}
                last_activity_date={
                  data?.referral_qualified ? data?.last_activity_date : null
                }
                refereeRole={data.referee_id_Role && data.referee_id_Role}
                referalRole={data.referred_id_Model && data.referred_id_Model}
                refDate={new Date(data.createdAt && data.createdAt)}
                enrollDate={new Date(data.enroll_date && data.enroll_date)}
              />
            );
          })}
      </React.Fragment>
    );
  };

  onDateChangeHandler = () => (data, type) => {
    this.setState({ dateQuery: data });
    this.getData(data);
  };
  setSort = (sort) => {
    this.setState({ sort: sort });
    this.renderTableDataBody();
  };
  render() {
    const downloadData = {
      headers: [
        { label: "Referrer ID", key: "ReferrerId" },
        { label: "Referrer code", key: "ReferralCode" },
        { label: "Referrer Name", key: "Referrername" },
        { label: "Referee ID", key: "refereeid" },
        { label: "Referee Name", key: "refereename" },
        { label: "Referee Role", key: "refereerole" },
        { label: "Referred Date", key: "Referrerdate" },
        { label: "Qualifying Activity", key: "qualifyingActivity" },
        { label: "Referral Qualified", key: "Qualified" },
        { label: "Qualifiying Activity Date", key: "qualifieddate" },
        { label: "Payable Amount To Refereer", key: "torefereer" },
        { label: "Payable Amount To Referee", key: "toreferee" },
        { label: "Contribution towards Udbhav", key: "toUdbhav" },
      ],
      data: this.state?.wholeData ? this.state?.wholeData?.map((ele) => {
        return {
          ReferrerId: ele?._id,
          ReferralCode: ele?.referee_id && ele?.referee_id.referral_code,
          Referrername:
            ele?.referee_id?.name || "Name not Given",
          refereeid: ele?.referred_id?._id,
          refereename:
            ele?.referred_id?.first_name + ele?.referred_id?.last_name,
            refereerole: ele?.referred_id_Model || "Name not Given ",
          Referrerdate: new Date(ele?.createdAt && ele?.createdAt),
          qualifyingActivity: "Registration",
          Qualified:
            ele?.referral_qualified && ele?.referral_qualified
              ? "Yes"
              : "No",
              qualifieddate:
              ele?.referral_qualified ? 
             ele?.last_activity_date
              ? moment(new Date(ele?.last_activity_date)).format("DD/MM/YYYY")
              : "N/A" : null,
              torefereer:` ₹ ${ele?.referralAmount || "0"}`,
              toreferee: `₹${ele?.refereeAmount || 0}`,
              toUdbhav: `₹${ele?.donation || 0}`,
        };
      }) : [],
    };
    return (
      <React.Fragment>
         <div className="row flexcenter">
          <div className="col-3 flexcenter">
          <Image
            onClick={() =>
              this.setState({ showSearch: !this.state.showSearch })
            }
            alt="search"
            title="search"
            width="80px"
            src={require("../../../../../assets/images/iconButton/newsearchicon.svg")}
          />
          <Image
            src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
            width="80px"
            alt="Filter"
            title="Filter"
            onClick={() =>
              this.setState({ filter: !this.state.filter })
            }
          />
         <SortTopRight
                setSort={this.setSort}
                filterItems={[
                  { title: "Referred Date & Time", disabled: true },
                  { title: "New to old", disabled: false },
                  { title: "Old to New", disabled: false },
                  // { title: "User Activity", disabled: true },
                  // { title: `Date & Time 🠑`, disabled: false },
                  // { title: "Date & Time 🠓", disabled: false },
                ]}
              />
          <CSVDownloader
            filename={"Affiliates Referral Report"}
            headers={downloadData.headers}
            data={downloadData.data}
          />
          </div>
          <div className="col-6">

          </div>
          <div className="col-3">
            <div className="mr-3">
              <SelectFilter defaultSelected={"TODAY"} onDateChange={this.onDateChangeHandler()} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            {this.state.showSearch && (
              <div className="mb-3">
                <ZoomDiv>
                  <>
                    <br />
                    <SearchWithIconInput
                      onChange={(e) =>
                        this.setState({ search: e.target.value })
                      }
                      search={this.state.search}
                    />
                  </>
                </ZoomDiv>
              </div>
            )}
          </div>
          <div className="col-9 p-0"></div>
          
          {/* <div className="col-2">
            <div className="d-flex align-items-center justify-content-between cursor-pointer">
              <SortTopRight
                setSort={this.setSort}
                filterItems={[
                  { title: "Referred Date & Time", disabled: true },
                  { title: "Old to New", disabled: false },
                  { title: "New to Old", disabled: false },
                  // { title: "User Activity", disabled: true },
                  // { title: `Date & Time 🠑`, disabled: false },
                  // { title: "Date & Time 🠓", disabled: false },
                ]}
              />
              <div
                className="f10-400"
                align="center"
                onClick={() => this.setState({ filter: !this.state.filter })}
              >
                <img
                  src={require("../../../../../assets/images/iconButton/filtericon.png")}
                  width="35px"
                />
                <br />
                Filter
              </div>

              <div className="f10-400" align="center">
                <CSVDownloader
                  filename={"Merchant Referral Report"}
                  headers={downloadData.headers}
                  data={downloadData.data}
                />
              </div>
            </div>
          </div> */}
        </div>
        <FilterMain
          filterOptions={
            <Row>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Status">
                    Referral Qualified
                    </InputLabel>
                    <Select
                      value={this.state.filterValue}
                      onChange={(e) =>
                        this.setState({ filterValue: e.target.value })
                      }
                      label="Referral Qualified"
                      inputProps={{
                        name: "Referred Rolen",
                        id: "outlined-Status",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {["All",
                        "Yes",
                        "No",
                      ].map((item, index) => (
                        <MenuItem label={item} value={item} key={index}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          }
          show={this.state.filter}
          onCancel={() => this.setState({ filter: false })}
          onFilter={() =>
            this.setState({ filterValueChecked: this.state.filterValue })
          }
        />
        <div className="super-admin-rating-review-tab super-admin-issues-open-users-tab">
          <TopNavigationReferralTab
            selectedTab={this.props.selectedTab}
            pageChanger={this.props.pageChanger}
          />
          {/* <div className="col-3 p-0">
            <SuperAdminTopSearchIcon />
          </div> */}
        </div>
        <div className="col-12 p-0 user-table-reusable-superadmin">
          <Table>
            <thead>
              <ReferralTableUserHeader
                headOne={
                  <>
                    Referrer
                    <br /> ID
                  </>
                }
                headTwo={
                  <>
                    Referrer
                    <br /> Code
                  </>
                }
                headThree="Referrer Name"
                headFour={
                  <>
                    Referee
                    <br /> ID
                  </>
                }
                headFive="Referee Name"
                headSix={
                  <>
                    Referee <br />
                    Role
                  </>
                }
                headSeven={
                  <>
                    Referred
                    <br /> Date
                  </>
                }
                headEight={
                  <>
                    Qualifying <br />
                    Activity
                  </>
                }
                headNine={
                  <>
                    Referral <br />
                    Qualified
                  </>
                }
                selectedTab={this.props.selectedTab}
               // headSix={
                //   <div className="d-flex justify-content-between">
                //     <div>Actions</div>
                //     <div className="d-flex align-items-center ">
                //       <Image
                //         fluid
                //         src={require("../../../../../assets/images/superadmin/sort-button-with-three-lines.svg")}
                //         className="sort-image"
                //       />
                //       <div className="ml-3">
                //         <Fillter />
                //       </div>
                //     </div> 
                //   </div>
                // }
              />
            </thead>
            <tbody style={{width:"100%",display:"inherit"}}>{this.renderTableDataBody()}</tbody>
          </Table>
        </div>
        {this.state?.referrals?.length > 0 ? (
                  <BasicPagination
                    totalRecords={this.state?.wholeData?.length}
                    limit={10}
                    batch={this.state.page}
                    onBatchChange={(e) => this.handleBatchChange(e)}
                  />
                ) : (
                  <> </>
                )}
      </React.Fragment>
    );
  }
}

// export default ReferralAffiliatesComponent;

ReferralAffiliatesComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  referrals: state.superAdminReferrals.affiliatesReferrals,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_refrrals_get,
})(withRouter(ReferralAffiliatesComponent));
